<!--
  进水水质监测
-->

<template>
  <div class="inlet">
    <ContentSection :title="'进水水质监测'" :mainStyle="{ borderRightStyle: 'solid' }">
      <div class="stat_main">
        <div class="yesterday">
          <!-- <div v-for="(item, index) in dataList" :key="index"
            :class="index == 4 ? 'yesterday_volume warning' : 'yesterday_volume'"> -->
          <div v-for="(item, index) in dataList" :key="index"
            :class="index == 4 ? 'yesterday_volume' : 'yesterday_volume'">
            <div class="data">
              <span>{{ item.Value }}</span>
              <br />
              <span>{{ item.Unit ? item.Unit : '' }} </span>
            </div>
            <!-- <canvas class="canvas" width="200" height="200"></canvas> -->
            <span class="y_title">{{ item.name }}</span>
          </div>
        </div>
      </div>
    </ContentSection>
  </div>
</template>

<script>
import ContentSection from "@/components/ContentSection";
import { getLatestByConfig } from "@/api/basic.js"
export default {
  name: "waterStat",
  components: {
    ContentSection,
  },
  data() {
    return {
      dataList: [
        {
          name: 'COD',
          Value: '1000.00',
          Unit: 'mg/L',
        },
        {
          name: '氨氮',
          Value: '25.00',
          Unit: 'mg/L',
        },
        {
          name: '总氮',
          Value: '25.00',
          Unit: 'mg/L',
        },
        {
          name: '总磷',
          Value: '5.00',
          Unit: 'mg/L',
        },
        {
          name: 'PH',
          Value: '14.00',
          Unit: '',
        },
        {
          name: '悬浮物',
          Value: '4000.00',
          Unit: 'mg/L',
        },
      ]
    };
  },
  mounted() {
    // this.setData();
    // this.beginCanvs();
  },
  methods: {
    // 获取值并赋给data对象，
    setData() {
      let data = {
        title: '',
        stagetype: 1,
        indicattype: 1
      }
      for (let i = 1; i <= 6; i++) {
        data.indicattype = i
        getLatestByConfig(data).then(res => {
          if (res.errorcode == 0) {
            let resData = res.resultdata.rows[0]
            // console.log(resData.NormalRange)
            if (!resData.RealParamInfo) {
              resData.RealParamInfo = {
                Value: 0,
                Unit: resData.Unit
              }
            }
            if (resData.EquipmentName.includes('化学需氧量')) {
              resData.RealParamInfo.name = 'COD'
            } else if (resData.EquipmentName.includes('PH')) {
              resData.RealParamInfo.name = 'PH'
            } else if (resData.EquipmentName.includes('悬浮物')) {
              resData.RealParamInfo.name = '悬浮物'
            } else if (resData.EquipmentName.includes('氨氮')) {
              resData.RealParamInfo.name = '氨氮'
            } else if (resData.EquipmentName.includes('总氮')) {
              resData.RealParamInfo.name = '总氮'
            } else if (resData.EquipmentName.includes('总磷')) {
              resData.RealParamInfo.name = '总磷'
            }
            // this.dataList[i - 1] = {... resData.RealParamInfo}
            this.$set(this.dataList ,i-1,{... resData.RealParamInfo})
            // this.$forceUpdate() 
            // console.log(this.dataList)

          }
        })
      }
    },
    // 开启canvas动画
    beginCanvs() {
      // let canvas = document.getElementById("canvas");
      let canvas = document.querySelectorAll(".canvas");
      let ctx = [canvas[0].getContext("2d"), canvas[1].getContext("2d")];
      let radians = (Math.PI / 180) * 180;
      let startTime = Date.now();
      let time = 1500;
      let clockwise = 1;
      let cp1x, cp1y, cp2x, cp2y;

      requestAnimationFrame(function waveDraw() {
        let t = Math.min(1.0, (Date.now() - startTime) / time);

        if (clockwise) {
          cp1x = 90 + 55 * t;
          cp1y = 28 + 72 * t;
          cp2x = 92 - 51 * t;
          cp2y = 179 - 79 * t;
        } else {
          cp1x = 145 - 55 * t;
          cp1y = 100 - 72 * t;
          cp2x = 41 + 51 * t;
          cp2y = 100 + 79 * t;
        }
        ctx.map((item) => {
          item.clearRect(0, 0, 200, 200);
          item.beginPath();
          item.moveTo(0, 100);
          // 绘制三次贝塞尔曲线
          item.bezierCurveTo(cp1x, cp1y, cp2x, cp2y, 200, 100);
          // 绘制圆弧
          item.arc(100, 100, 100, 0, radians, 0);
          // item.fillStyle = "rgba(84, 155, 206, 1)";
          item.fillStyle = "#fff";
          item.fill();
          item.save();
        });

        if (t == 1) {
          startTime = Date.now();
          clockwise = !clockwise;
        }

        requestAnimationFrame(waveDraw);
      });
    },
  },
};
</script>

<style lang="less" scoped>
.inlet {
  .stat_main {
    margin: auto;
    // padding-top: 57vh * @vh;
    box-sizing: border-box;
    color: #fff;
    height: 505vh * @vh;

    .yesterday {
      margin: auto;
      display: grid;
      grid-template-columns: repeat(3, 1fr);

      .warning {
        background-image: url("@/assets/img/stat_content_warning_back.png") !important;
      }

      .yesterday_volume {
        width: 282px;
        // height: 282vh * @vh;
        height: 282px;
        background-image: url("@/assets/img/stat_content_back.png");
        background-size: 100% 100%;
        position: relative;

        .y_title {
          font-size: 30px;
          position: absolute;
          bottom: -20px;
          left: 50%;
          transform: translateX(-50%);
        }

        .canvas {
          width: 282px;
          height: 120px;
          box-sizing: border-box;
          border-radius: 100%;
          position: absolute;
          top: 55%;
          left: 11%;
          transform: translateY(-50%);
          z-index: -1;
        }

        .data {
          font-size: 40px;
          position: absolute;
          top: 50%;
          // left: 85px;
          left: 50%;
          transform: translate(-50%, -50%);

          span:first-child {
            font-family: PMZ;
          }
        }
      }
    }
  }
}

@media screen and (min-width: 3640px),screen and(max-height: 1080) {
    .inlet {
      .stat_main {
        // height: 505vh * @vh;
        .yesterday {
          margin-left: 50px;
          .yesterday_volume {
            width: 132px;
            height: 132px;
            .y_title {
              font-size: 20px;
              position: absolute;
              bottom: -20px;
              left: 50%;
              transform: translateX(-50%);
            }

            .data {
              font-size: 20px;
            }
          }
        }
      }
    }
  }
</style>